<template>
  <b-card
    v-if="data"
    no-body
    class="card-statistics"
  >
    <slot name="hint" />
    <b-card-header>
      <b-card-title>{{ title }}</b-card-title>
      <b-card-text
        v-if="showUpdated"
        class="font-small-2 mr-25 text-muted"
      >
        {{ updated }}
      </b-card-text>
      <b-button
        v-if="createPortfolio"
        variant="primary"
        @click.prevent="$emit('create-portfolio')"
      >
        Create Portfolio
      </b-button>
    </b-card-header>
    <b-card-sub-title
      v-if="explanation"
      class="statistics-explanation"
    >
      {{ explanation }}
    </b-card-sub-title>
    <b-card-body :class="['statistics-body', 'd-flex', loading ? 'align-items-center' : 'align-items-end']">
      <loading-container
        v-if="loading"
        class="flex-grow-1"
        :padding-y="1"
      />
      <no-data-container v-else-if="!data || data.length < 0" />
      <b-row
        v-else
         class="w-100"
      >
        <b-col
          v-for="(item, index) in filteredData"
          :key="`${item.subtitle}-${index}`"
          :class="`${item.customClass} d-flex align-items-end`"
        >
          <!-- <b-col
            v-for="item in data"
            :key="item.icon"
            xl="3"
            sm="6"
            :class="item.customClass"
          > -->
          <div
            v-if="item.subtitle === 'All products'"
            class="vertical-divider"
          />
          <b-media no-body>
            <b-media-aside

              class="mr-1"
            >
              <b-avatar
                size="38"
                :variant="item.color"
                rounded
              >
                <feather-icon
                  size="20"
                  :icon="item.icon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0 statistic-title">
                {{ item.title }}
              </h4>
              <b-card-text class="font-small-3 mb-0 statistic-subtitle">
                {{ item.subtitle }}
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardSubTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody, BButton,
} from 'bootstrap-vue'

import LoadingContainer from '@/views/components/LoadingContainer.vue'
import NoDataContainer from '@/views/components/NoDataContainer.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardSubTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BButton,
    LoadingContainer,
    NoDataContainer,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    updated: {
      type: String,
      default: '',
    },
    explanation: {
      type: String,
      default: '',
    },
    data: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    createPortfolio: {
      type: Boolean,
      default: false,
    },
    showUpdated: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    filteredData() {
      return this.data.filter(item => item.subtitle !== 'All products')
    },
  },
}
</script>

<style lang="scss" scoped>
.vertical-divider {
  width: 1px;
}

@media (min-width: 992px) {
  .vertical-divider {
    width: 1px;
    background: rgba(91,99,161,0.5);
    height: 100%;
    margin-right: 50px;
  }
}

.card-statistics ::v-deep .card-header {
  padding-bottom: 0 !important;
}

.statistic-subtitle {
  text-transform: capitalize;
}

.statistics-explanation {
  color: #6c757d;
  font-size: 1rem;
  padding: 0 1.5rem;
  margin-top: 0.25rem;
  margin-bottom: 0.5rem;
}

.statistics-body {
  padding-bottom: 1.5rem !important;
  min-height: 40px;
}

.rounded-square-avatar {
  border-radius: 0.5rem !important;
}
</style>
